import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
var keyFeaturesPerRoute = {
    OfficeHome: [
        'Shell',
        'AppBar',
        'QuickAccess',
        'MRU',
        'Recommended',
        'CreateOnHome',
    ],
    Pwa: [
        'Shell',
        'AppBar',
        'QuickAccess',
        'MRU',
        'Recommended',
        'CreateOnHome',
    ],
    Start: ['Shell', 'AppBar', 'Templates', 'Recommended', 'EdgeworthFirst'],
    Create: ['Shell', 'AppBar', 'CreateCenter'],
};
export function getKeyFeatures() {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var context, route, routeName, features;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, fetchOfficeComponentContext()];
                case 1:
                    context = _c.sent();
                    route = (_a = context === null || context === void 0 ? void 0 : context.router) === null || _a === void 0 ? void 0 : _a.getCurrentRoute();
                    routeName = route === null || route === void 0 ? void 0 : route.route;
                    features = routeName ? (_b = keyFeaturesPerRoute[routeName]) !== null && _b !== void 0 ? _b : [] : [];
                    return [2 /*return*/, new Set(features)];
            }
        });
    });
}
//# sourceMappingURL=getKeyFeatures.js.map